<template>
  <base-dialog
    class="import-excel"
    v-model="visible"
    @ok="doImport"
    width="600px"
    :ok-text="okText"
    :ok-loading="okLoading"
    :ok-disabled="okDisabled"
    :show-cancel="false"
  >
    <h3 v-if="template">
      导入模版：<a target="_blank" :href="template.url">{{ template.label }}</a>
    </h3>
    <div style="color: red; margin-bottom: 10px">温馨提示：文件需解密</div>
    <form class="form-hide" ref="form">
      <input ref="file" type="file" @change="change" />
    </form>
    <div v-if="rawFile">
      <div v-if="excelData" style="margin-bottom: 10px">{{ rawFile.name }}</div>
      <div v-else><i class="el-icon-loading"></i>读取Excel中...</div>
      <el-progress
        v-if="okLoading"
        :text-inside="true"
        :stroke-width="16"
        :percentage="progress"
      ></el-progress>
    </div>
    <el-button v-else @click="selectFile">选择Excel文件</el-button>
    <slot></slot>
  </base-dialog>
</template>
<script>
import parseExcel from '../plugins/parseExcel'
export default {
  name: 'import-excel',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    template: Object,
    splice: {
      type: Number,
      default: 1000,
    },
    columnMap: Object,
    valueConvert: Object,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      count: 0, //回调导入次数
      okText: '导入',
      okLoading: false,
      okDisabled: true,
      excelData: null,
      excelDataCount: 0,
      importCount: 0,
      rawFile: null,
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
    progress() {
      if (this.importCount && this.excelDataCount) {
        return parseInt((this.importCount / this.excelDataCount) * 100)
      }
      return 0
    },
  },
  methods: {
    reset() {
      this.count = 0
      this.okText = '导入'
      this.okLoading = false
      this.okDisabled = true
      this.excelData = null
      this.excelDataCount = 0
      this.importCount = 0
      this.clearFile()
    },
    clearFile() {
      this.rawFile = null
      if (this.$refs.form && this.$refs.form.reset) {
        this.$refs.form.reset()
      }
    },
    change(e) {
      if (e.target.files[0]) {
        this.rawFile = e.target.files[0]
        parseExcel
          .load(this.rawFile, this.columnMap, this.valueConvert || {})
          .then((json) => {
            this.excelData = json
            this.excelDataCount = json.length
            this.okDisabled = false
          })
          .catch((error) => {
            console.error(error)
            this.$message('读取Excel失败')
          })
      }
    },
    selectFile(e) {
      var evt = document.createEvent('MouseEvent')
      evt.initEvent('click', true, true)
      this.$refs.file.dispatchEvent(evt)
    },

    doImport() {
      if (this.excelData == null || this.excelData.length <= 0) {
        this.$message('读取到Excel数据为空')
        return
      }
      this.okLoading = true
      this.nextImport()
      this.$emit('start-import')
    },
    nextData(len) {
      if (this.excelData.length < len) {
        len = this.excelData.length
      }
      this.count++
      return this.excelData.splice(0, len)
    },
    nextImport() {
      var data = this.nextData(this.splice)
      if (data.length > 0) {
        this.importCount += data.length
        this.$emit('do-import', data, this.nextCallback, this.count)
      } else {
        this.okLoading = false
        this.$message({
          type: 'success',
          message: '导入成功',
        })
        this.visible = false
        this.reset()
        this.$emit('success')
      }
    },
    nextCallback(flag) {
      if (flag) {
        this.nextImport()
      } else {
        this.reset()
      }
    },
  },
}
</script>
<style lang="less">
.import-excel {
  .form-hide {
    display: none;
  }
}
</style>